module.exports = __webpack_public_path__ + "static/media/company-logo-default.d8e6dbe0.png";